import api from '@/api/articleApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_CHANNELS_ARTICLE, LOAD_CHANNELS_ROOT, SEO } from '../protocols';
export interface State {
    feeds: ArticleFeed[],
    feedIndex: number,
    feedsVisible: boolean,
    article: Article | null,
}
class ArticleHome extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_ARTICLE[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                feeds: [],
                feedIndex: -1,
                feedsVisible: false,
                article: null,
            },
            mutations: {
                updateArticle(state, data) {
                    state.article = data
                }
            },
            actions: {
                async loadFeeds({ state, dispatch }, key: string) {
                    try {
                        state.feeds = await api.getFeeds(1, 7, key)
                    } catch (e) {
                        state.feeds = []
                    } finally {
                        state.feedIndex = -1
                    }
                },
                async loadContent({ dispatch, commit, state }, route: Route) {
                    try {
                        let id = route.params.id
                        state.article = await api.getDetail(id)

                        dispatch('loadFeeds', state.article.username)

                        let seoTitle = state.article.title + '-福音阅读-频道-福音影视网|福音TV'
                        commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    } catch (e) {
                    }
                },
                [LOAD_CHANNELS_ARTICLE[1]]({ dispatch, state, commit }, route: Route) {
                    return Promise.all([
                        dispatch(LOAD_CHANNELS_ROOT[0] + '/loadLeft', {}, { root: true }),
                        dispatch('loadContent', route),
                    ])
                }
            }
        }
    }
}

export default new ArticleHome();